export const enTranslations = {
    "scratch_card": {
      "preview_blocked": "Preview mode — cannot claim the card.",
      "select_error": "Unable to claim the card right now. Please try again.",
      "topup_error": "Unable to top up right now. Please check the phone number and try again.",
    },
    "common": {
      "loading": "Loading...",
      "check_product_info": "Check Product Information",
      "not_found": "Not Found",
      "not_found_content": "The content you are looking for does not exist.",
      "error": "System Error",
      "back_to_home": "Back to Home",
      "all_rights_reserved": "All rights reserved",
      "phone": "Phone",

      "hotline": "Contact Hotline: {{phone}}",
      "email": "Email",
      "contact": "Contact",
      "contact_info": "Contact Information",
      "customer_info": "Customer Information",
      "product_info": "Product Information",
      "product_code": "Product Code",
      "product_name": "Product Name",
      "product_price": "Product Price",
      "related_products": "Related Products",
      "product_description": "Product Description",
      "brand": "Brand",
      "category": "Category",
      "verification_form": "Verification Form",
      "verified_localtion": "Verified Location",
      "verify": "Verify",
      "verification_product": "Product Verification",
      "verify_message": "Please enter the verification code below. Then click the Verify button to authenticate the product.",
      "note_verification": "Note: Verification information will be kept confidential",
      "distribution_info": "Distribution Information",
      "verification_info": "Verification Information",
      "stamp_blocked_title": "Stamp Blocked",
      "stamp_blocked_content": "This stamp has been blocked due to policy violation.",
      "stamp_new_title": 'New Stamp Code',
      "stamp_new_content": "This is a new stamp that has not been activated.",
      "stamp_verify_success": "Stamp verification successful!",
      "stamp_activated_content": "Stamp has been activated previously.",
      "unauthorized_access": "Unauthorized Access",
      "unauthorized_content": "You do not have permission to access this content.",
      "congratulations": "Congratulations!",
      "congratulations_content": "You have purchased an authentic PISEN product. Please fill in the information to activate PISEN Care Plus warranty from 2-6 months.",
      "help_contact": "For any inquiries, please contact",
      "verification_date": "Verification Date",
      "remaining_days": "Warranty days remaining",
      "days": "days",
      "warranty_replaced": "Warranty replaced",
      "verify_code": "Verification Code",
      "customer_name": "Customer Name",
      "phone_number": "Phone Number",
      "internal_notes": "Internal Notes",
      "stamp_note": "Stamp Note"
    },
    "kichhoat": {
      "title": "Activate product warranty",
      "enter_code": "Scratch code",
      "enter_code_placeholder": "Enter scratch code...",
      "enter_serial": "Serial (barcode)",
      "enter_serial_placeholder": "Enter serial...",
      "submit": "Activate warranty",
      "code_required": "Please enter the scratch code",
      "serial_required": "Please enter the serial",
      "congratulations": "Congratulations!",
      "congratulations_content": "Your product is genuine. Please fill in your information to activate the warranty.",
      "customer_name": "Customer name",
      "phone_number": "Phone number",
      "enter_name_placeholder": "Enter customer name...",
      "enter_phone_placeholder": "Enter phone number...",
      "send_info": "Submit information",
      "product_name": "Product name",
      "warranty_days": "Warranty period",
      "warranty_period": "Warranty start time",
      "remaining_days": "Warranty days remaining",
      "days": "days",
      "suspicious_title": "THIS PRODUCT LOOKS SUSPICIOUS",
      "suspicious_content": "Please contact the nearest dealer/distributor for more details.",
      "name_required": "Please enter the customer name",
      "phone_required": "Please enter the phone number",
      "phone_invalid": "Invalid phone number",
      "error": "Something went wrong. Please check your information or contact the hotline."
    },
    "form": {
      "full_name": "Full Name",
      "phone_number": "Phone Number",
      "email": "Email",
      "address": "Address",
      "enter_name": "Enter full name",
      "enter_phone": "Enter phone number",
      "enter_email": "Enter email",
      "enter_address": "Enter address",
      "name_required": "Please enter full name",
      "phone_required": "Please enter phone number",
      "phone_invalid": "Invalid phone number",
      "email_invalid": "Invalid email",
      "verification_code_required": "Please enter verification code",
      
      "error_content": "An error has occurred. Please check the verification code or contact the hotline for assistance. Thank you!",
      "limit_scan_content": "Scan limit exceeded. Please contact the hotline for support.",
      "stamp_warranty_replaced": "The product has been replaced under warranty.",
      "stamp_verified": "The product has been verified previously. Please check again or contact the seller for assistance!",
      "stamp_blocked_content": "The stamp code is blocked. Please contact the hotline for support.",
      "stamp_verify_success": "Congratulations! This is an authentic product. Thank you for your purchase!",
      "stamp_new_content": "The product has not been released yet. Please contact the hotline for assistance.",
      "stamp_processing_content": "The product is currently being processed. Please check again or contact the seller for assistance!",
      
      "stamp_cannot_access_scan_stamp_title": "Warning",
      "stamp_cannot_access_scan_stamp_content": "This product is not allowed to be verified on the landing page app. Please check again or contact the seller for assistance!",
    },
    "placeholders": {
      "verify_code": "Enter verification code",
      "customer_name": "Enter customer name",
      "phone_number": "Enter phone number",
    },
    "buttons": {
      "verification": "Verification",
    },
    "warning": {
      "preview_mode": "Warning. You are in preview mode, we do not allow code verification."
    },
    "error": {
      "verification_failed": "Verification failed. Please try again."
    },
    "stamp_status": {
      "checking": 'Checking',
      "new": 'New',
      "product_assigned": 'Product assigned',
      "processing": 'Processing',
      "sold": 'Sold',
      "warranty_processing": 'Warranty processing',
      "warranty_replaced": 'Warranty replaced',
      "activated": 'Activated',
      "blocked": 'Blocked',
      "not_enough_stamp": 'Not enough stamp',
      "out_of_stamp": 'Out of stamp',
      "over_limited": 'Activated',
    }
};
